<div class="field-container">
  <div class="label-container">
    <label [for]="id" [id]="id + '-label'" ellipsis>
      <ng-content></ng-content>

      <span *ngIf="required" class="required" aria-hidden="true">
        *
      </span>
    </label>
  </div>

  <div class="input-container composable-element" [class.with-icon]="icon" (click)="focus()">
    <input
      #inputEl
      [matAutocomplete]="matAutocomplete"
      [matAutocompleteDisabled]="!matAutocomplete"
      [matAutocompleteConnectedTo]="matAutocompleteConnectedTo"
      [attr.aria-autocomplete]="ariaAutocomplete"
      [attr.aria-activedescendant]="ariaActiveDescendant"
      [attr.aria-controls]="ariaControls"
      [attr.aria-haspopup]="ariaHasPopup"
      [attr.aria-describedby]="errorId"
      [attr.aria-invalid]="invalid"
      [attr.aria-required]="required"
      [autofocus]="autofocus"
      [autocomplete]="autocomplete"
      [disabled]="isDisabled"
      [id]="id"
      [max]="max"
      [min]="min"
      [minlength]="minLength"
      [maxlength]="maxLength"
      [name]="name"
      [(ngModel)]="value"
      [readonly]="readonly"
      [attr.role]="role"
      [type]="type"
      (blur)="handleOnTouch($event)"
      (input)="onChange(value)"
      (paste)="handleOnPaste($event)"
    >

    <opac-icon *ngIf="icon" [icon]="icon" (click)="handleIconClick($event)"></opac-icon>
  </div>

  <div class="support-text">
    <span aria-live="assertive" class="error-text" [id]="errorId">
      <ng-content select="[slot='error']"></ng-content>
    </span>

    <span *ngIf="counter && maxLength < infinity" aria-hidden="true">{{value.length}}/{{maxLength}}</span>
  </div>
</div>
